<template>
  <v-dialog v-model="dialog" max-width="850" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        color="orange"
        block
        outlined
        elevation="2"
        rounded
        class="font-weight-bold white mt-4"
        style="border-color: orange !important"
        >Reenviar documentos</v-btn
      >
    </template>
    <v-progress-linear indeterminate v-if="loadingDocs"></v-progress-linear>
    <anexar-docs-plano-saude
      v-else
      :dependentes="solicitacao.dependentes"
      :codConfig="17"
    >
      <v-spacer></v-spacer>
      <v-dialog v-model="dialogActTermos" scrollable max-width="650">
        <template v-slot:activator="{ on, attrs }">
          <v-btn min-width="200" rounded v-on="on" v-bind="attrs" color="info"
            >Confirmar documentos</v-btn
          >
        </template>
        <texto-aceitar-termos>
          <v-spacer></v-spacer>
          <v-btn
            @click="enviarCorrecaoDocs()"
            rounded
            color="info"
            min-width="200"
            :disabled="!aceitouTermos"
            :loading="enviandoCorrecao"
            >Confirmar</v-btn
          >
          <v-btn text @click="dialogActTermos = false" rounded>Fechar</v-btn>
        </texto-aceitar-termos>
      </v-dialog>
      <v-btn rounded text @click="dialog = false">Fechar</v-btn>
    </anexar-docs-plano-saude>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapActions, mapMutations, mapState } from "vuex";
import AnexarDocsPlanoSaude from "../components/AnexarDocsPlanoSaude.vue";
import TextoAceitarTermos from "../components/TextoAceitarTermos.vue";

export default {
  watch: {
    dialog: async function (open) {
      if (open) {
        this.loadingDocs = true;
        await this.getConfigDocs();
        this.loadingDocs = false;
      }
    },
    dialogActTermos: async function (open) {
      if (open) {
        this.setAceitouTermos(false);
        await this.getTextoAceitarTermos();
      }
    },
  },
  props: {
    solicitacao: Object,
  },
  components: { AnexarDocsPlanoSaude, TextoAceitarTermos },
  computed: mapState("planoSaude", ["aceitouTermos", "docsAnexados"]),
  data: () => ({
    dialog: false,
    loadingDocs: true,
    dialogActTermos: false,
    enviandoCorrecao: false,
  }),
  methods: {
    ...mapMutations("planoSaude", ["setAceitouTermos"]),
    ...mapActions("planoSaude", [
      "getConfigDocs",
      "getTextoAceitarTermos",
      "getSolicitacoes",
    ]),
    async enviarCorrecaoDocs() {
      this.enviandoCorrecao = true;
      await axios
        .post(
          "/colaborador/plano-saude/alterar-status-solicitacao",
          JSON.stringify({
            codigo: this.solicitacao.codigo,
            documentos: this.docsAnexados,
            dependentes: this.solicitacao.dependentes,
            cod_status: 1,
            ambiente: "WEB",
          })
        )
        .then(async (res) => {
          if (res.data.success) {
            this.$toasted.success(res.data.msg);
            await this.getSolicitacoes();
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
      this.enviandoCorrecao = false;
    },
  },
};
</script>

<style>
</style>